
import * as handlebars_family from "../handlebars_family.ts";

const TPL = handlebars_family.addTemplate("filer/folder_list_item",{"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<flexrow data-fw-meta-id=\""
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"metaId") : depth0), depth0))
    + "\" class=\"filer-folder border-pane\" data-fw-onclick=\"controllerselect\" style=\"height:64px\"><icon style=\"font-size:40px;position:relative\"><icon style=\"font-size:inherit\">"
    + container.escapeExpression((lookupProperty(helpers,"iconlib")||(depth0 && lookupProperty(depth0,"iconlib"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),"filer.folder_colored",(depth0 != null ? lookupProperty(depth0,"color") : depth0),{"name":"iconlib","hash":{},"data":data,"loc":{"start":{"line":1,"column":207},"end":{"line":1,"column":247}}}))
    + "</icon><emoji style=\"position:absolute;left:8px;top:8px;\">"
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"emoji") : depth0), depth0))
    + "</emoji></icon><flexauto><line>"
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"name") : depth0), depth0))
    + "</line><line class=\"sub4\"> "
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"subLine") : depth0), depth0))
    + " </line></flexauto></flexrow>";
},"useData":true});
export default TPL;